<script setup lang="ts">
import BaseForm from "~/components/ui/BaseForm.vue";
import ProgressBar from "~/components/ui/ProgressBar.vue";
import FormCard from "~/components/ui/FormCard.vue";
import {getThemeData} from "~/utils";

const local = await getLocale("forms", "club_consent", "it", true);
import { CLUB_PRIVACY_URL } from "~/utils/constants";

const emit = defineEmits(["init", "submit", "decline"]);

defineComponent({
  name: "ClubUciConsent",
});

defineProps({
  progress: { type: Number, required: true },
  title: { type: String, required: true },
  installment: { type: String, required: true },
});

onMounted(() => emit("init"));

const clubInfoUrl = computed(() => {
  const baseUrl = getThemeData().endpoints.club_platform;
  return baseUrl ? `${baseUrl}unicredit/` : ''
});

</script>

<template>
  <BaseForm>
    <template #upper>
      <ProgressBar :value="progress" />
      <FormCard :title="title" class="leading-6" @submit="emit('submit')">
        <p
          class="mb-4"
          v-html="
            local.paragraph_1.replace('%d', `${installment}`).replace('%d', clubInfoUrl)
          "
        ></p>
        <p
          class="mb-4"
          v-html="local.paragraph_2"
        ></p>
      </FormCard>

      <div class="text-center text-gray-700 mt-4 mb-8">
        <button
          class="underline"
          data-testid="decline"
          @click="() => $emit('decline')"
        >
          {{ local.continue_without_club }}
        </button>
      </div>
      <div class="spacer h-6"></div>
    </template>

    <template #bottom-out>
      <p class="italic px-4">{{ local.disclaimer }}</p>
    </template>
  </BaseForm>
</template>

<style scoped></style>
